import React from 'react';
import styled from '@emotion/styled';

import TagV2 from '../TagV2';
import { TagV2Variant } from '../TagV2.styles';

const StyledTagV2 = styled(TagV2)`
  font-weight: @font-weight-regular;
  text-transform: none;
  margin: 5px 4px;
`;

export interface CollaboratorTagProps {
  text: string;
  className?: string;
}

const CollaboratorTag: React.FC<CollaboratorTagProps> = ({ className, text }) => (
  <StyledTagV2 className={className} variant={TagV2Variant.PURPLE}>
    {text}
  </StyledTagV2>
);

export default CollaboratorTag;
